import { UUID } from 'types/shared/UUID';

export interface IDocumentAccessResponse {
  id: string;
  createdAt: string;
  createdBy: UUID;
  expired: boolean;
  expiresAt: string;
  expiredManuallyAt: string;
  expiredManuallyBy: UUID;
  downloadUrl: string;
}

export type IDocumentAccessData = IDocumentAccessResponse;

export const convertIDocumentAccessResponseToIDocumentAccessData = (
  response: IDocumentAccessResponse
): IDocumentAccessData => response;
